module.exports = __webpack_public_path__ + "img/IMG_2024_FoamcoreMatted.9a68d7ad.jpg";